var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 3.33301H2.67283V4.66634H1.3335V3.33301Z",
    fill: "#697180"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00016 3.33301H14.6668V4.66634H4.00016V3.33301Z",
    fill: "#697180"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 7.33301H2.67283V8.66634H1.3335V7.33301Z",
    fill: "#697180"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00016 7.33301H14.6668V8.66634H4.00016V7.33301Z",
    fill: "#697180"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 11.333H2.67283V12.6663H1.3335V11.333Z",
    fill: "#697180"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00016 11.333H14.6668V12.6663H4.00016V11.333Z",
    fill: "#697180"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.7a1c4e00ee5633ee1849b79be84a5e51.svg";
export { ForwardRef as ReactComponent };